import * as actionTypes from '../actions/actionTypes';
import {updateState} from "../../shared/util";

const initialState = {
    coupon: null,
    couponOff: false,
    loading: false,
    error: null
};

const getCouponRequest = (state, action) => {
    return updateState(state, {
        loading: true
    });
};

const getCouponSuccess = (state, action) => {
    let couponOff = action.coupon === "" || action.coupon === undefined;

    return updateState(state, {
        loading: false,
        coupon: action.coupon,
        couponOff
    });
};

const getCouponError = (state, action) => {
    return updateState(state, {
        error: action.error
    });
};

const clearCoupon = (state, action) => {
    return updateState(state, {
        coupon: null
    });
};

const clearCouponOff = (state, action) => {
    return updateState(state, {
        couponOff: false
    })
};

export function couponReducer(state=initialState, action) {
    switch(action.type) {
        case actionTypes.GET_COUPON_REQUEST :
            return getCouponRequest(state, action);
        case actionTypes.GET_COUPON_SUCCESS :
            return getCouponSuccess(state, action);
        case actionTypes.CLEAR_COUPON :
            return clearCoupon(state, action);
        case actionTypes.GET_COUPON_ERROR :
            return getCouponError(state, action);
        case actionTypes.CLEAR_COUPON_OFF :
            return clearCouponOff(state, action);
        default :
            return state;
    }
}
